import React from "react";

interface AppointmentHeaderProps {
  patientName?: string;
  appointmentType?: string; // "TELECONSULTATION" | "INCLINIC" also possible
}

const AppointmentHeader: React.FC<AppointmentHeaderProps> = ({
  patientName,
  appointmentType,
}) => {
  return (
    <div className="bg-teal-700 shadow-md mb-4">
      <div className="flex items-center gap-4 p-4 justify-center max-w-4xl mx-auto">
        <svg
          width="48"
          height="48"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="animate-pulse flex-shrink-0"
        >
          <path
            d="M27 49.5C39.375 49.5 49.5 39.375 49.5 27C49.5 14.625 39.375 4.5 27 4.5C14.625 4.5 4.5 14.625 4.5 27C4.5 39.375 14.625 49.5 27 49.5Z"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.4375 26.9998L23.805 33.3673L36.5625 20.6323"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <div className="flex flex-col text-white leading-snug">
          <p className="text-base sm:text-lg font-bold">
            Dear {patientName}, your{" "}
            {appointmentType === "TELECONSULTATION"
              ? "Teleconsultation"
              : "In-clinic"}{" "}
            appointment is booked!
          </p>
        </div>
      </div>
    </div>
  );
};

export default AppointmentHeader;
